<div>

    <form [formGroup]="createProfessionalForm" (ngSubmit)="onSubmit()">
        <h2>Créer son compte Professionnel Amelipro</h2>

        <div class="tui-form__row mb-1">
            <div class="row">
                <div class="col col-6">
                    <tui-input label="Nom" formControlName="lastName">
                        Nom<span class="tui-required"></span>
                    </tui-input>
                    @if (createProfessionalForm.get('lastName')?.touched &&
                    createProfessionalForm.get('lastName')?.invalid) {
                    <div>
                        <small style="color: var(--tui-status-negative)">Prénom est obligatoire !</small>
                    </div>
                    }
                </div>
                <div class="col col-6">
                    <tui-input label="Prénom" formControlName="firstName">
                        Prénom<span class="tui-required"></span>
                    </tui-input>
                    @if (createProfessionalForm.get('firstName')?.touched &&
                    createProfessionalForm.get('firstName')?.invalid) {
                    <div>
                        <small style="color: var(--tui-status-negative)">Nom est obligatoire !</small>
                    </div>
                    }
                </div>
            </div>
        </div>

        <div class="tui-form__row mb-1">
            <tui-input label="RPPS" formControlName="rpps">
                RPPS<span class="tui-required"></span>
            </tui-input>
            @if (createProfessionalForm.get('rpps')?.touched && createProfessionalForm.get('rpps')?.invalid) {
            <div>
                <small style="color: var(--tui-status-negative)">RPPS is required!</small>
            </div>
            }
        </div>

        <div class="tui-form__row mb-1">
            <tui-select id="qualification" formControlName="qualification">
                Qualification *
                <input placeholder="Qualification" tuiTextfieldLegacy />
                <tui-data-list-wrapper *tuiDataList [items]="qualifications" />
            </tui-select>
        </div>

        <div class="tui-form__row mb-1" tuiAppearance="floating" tuiCardLarge>
            <span tuiSubtitle>Signature</span>
            <signature-pad [options]="signaturePadOptions" (onEndEvent)="drawComplete()"
                formControlName="signature"></signature-pad>
        </div>

        <div class="tui-form__row mb-1">
            <label tuiLabel>
                <input tuiCheckbox type="checkbox" formControlName="accept" />
                <span tuiTitle style="display: inline;">
                    J'ai lu et j'accepte <a tuiLink href="assets/ordoclic/CGU_Ordoclic.pdf" target="_blank">les
                        conditions
                        générales d'utilisation</a> d'Ordoclic, et je reconnais avoir pris connaissance
                    de <a tuiLink href="assets/ordoclic/Politique-de-confidentialité-Ordoclic.pdf" target="_blank">la
                        politique
                        de confidentialité</a> applicable au traitement de mes données à caractère personnel.
                </span>
            </label>
        </div>

        <div *ngIf="errorMessage" class="error-message tui-space_bottom-3">
            <tui-notification appearance="negative">{{ errorMessage }}</tui-notification>
        </div>

        <div class="tui-form__buttons">
            <button tuiButton class="tui-form__button" size="l" type="submit"
                [disabled]="createProfessionalForm.invalid">Créer son compte Ordoclic/Amelipro</button>
        </div>

    </form>

</div>